export * from "./atoms";

import { DepartmentAtoms } from "./atoms";

export const DepartmentComponents = [
    ...DepartmentAtoms
];
